import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { push } from 'react-router-redux';
import {
  CLEAR_BUS_ASSIGNMENT_SCHEDULE,
  CLEAR_BUS_ASSIGNMENT_SCHEDULES,
  FLAG_BUS_ASSIGNMENT_SCHEDULE_ACTIVITY,
  FLAG_BUS_ASSIGNMENT_SCHEDULES,
  GET_BUS_ASSIGNMENT_SCHEDULE,
  GET_BUS_ASSIGNMENT_SCHEDULES,
} from '../types';
import { BUS_ASSIGNMENT_SCHEDULE_ENDPOINT } from '../../config/endpoints';
import {
  DEFAULT_DELETE_CONFIG,
  DEFAULT_GET_CONFIG,
  DEFAULT_POST_CONFIG,
  DEFAULT_PUT_CONFIG,
} from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import { BUS_ASSIGNMENT_SCHEDULE_PATH } from '../../config/paths';

const flagGettingBusAssignmentSchedules = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BUS_ASSIGNMENT_SCHEDULES,
    payload: flag,
  });

const getBusAssignmentSchedules = async (tableFilters) => async (dispatch) => {
  try {
    dispatch(flagGettingBusAssignmentSchedules(true));
    const query = tableFilters;
    const url = `${BUS_ASSIGNMENT_SCHEDULE_ENDPOINT}?${QueryString.stringify(
      query,
    )}`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const response = await promise.json();
    dispatch({
      type: GET_BUS_ASSIGNMENT_SCHEDULES,
      payload: response,
    });
  } catch ({ message }) {
    toastr.error('Error', message);
  } finally {
    dispatch(flagGettingBusAssignmentSchedules(false));
  }
};

const clearBusAssignmentSchedules = () => (dispatch) =>
  dispatch({
    type: CLEAR_BUS_ASSIGNMENT_SCHEDULES,
  });

const flagBusAssignmentScheduleActivity = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_BUS_ASSIGNMENT_SCHEDULE_ACTIVITY,
    payload: flag,
  });

const getBusAssignmentSchedule =
  async ({ busAssignmentScheduleId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBusAssignmentScheduleActivity(true));
      const url = `${BUS_ASSIGNMENT_SCHEDULE_ENDPOINT}/${busAssignmentScheduleId}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();
      dispatch({
        type: GET_BUS_ASSIGNMENT_SCHEDULE,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBusAssignmentScheduleActivity(false));
    }
  };

const clearBusAssignmentSchedule = () => (dispatch) =>
  dispatch({
    type: CLEAR_BUS_ASSIGNMENT_SCHEDULE,
  });

const deleteBusAssignmentSchedule =
  async ({ busAssignmentScheduleId }) =>
  async (dispatch) => {
    try {
      dispatch(flagBusAssignmentScheduleActivity(true));
      const url = `${BUS_ASSIGNMENT_SCHEDULE_ENDPOINT}/${busAssignmentScheduleId}`;
      const promise = await fetch(url, { ...DEFAULT_DELETE_CONFIG });
      await isErrorResponse(promise, null, dispatch);
      dispatch(push(BUS_ASSIGNMENT_SCHEDULE_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBusAssignmentScheduleActivity(false));
    }
  };

const postBusAssignmentSchedule =
  async ({ startDate, endDate, busIdList, circuitIdList }) =>
  async (dispatch) => {
    try {
      dispatch(flagBusAssignmentScheduleActivity(true));
      const url = BUS_ASSIGNMENT_SCHEDULE_ENDPOINT;
      const payload = {
        startDate,
        endDate,
        busIdList,
        circuitIdList,
      };
      const promise = await fetch(url, {
        ...DEFAULT_POST_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(push(BUS_ASSIGNMENT_SCHEDULE_PATH));
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBusAssignmentScheduleActivity(false));
    }
  };

const putBusAssignmentSchedule =
  async (
    busAssignmentScheduleId,
    { startDate, endDate, busIdList, circuitIdList, active },
  ) =>
  async (dispatch) => {
    try {
      dispatch(flagBusAssignmentScheduleActivity(true));
      const url = `${BUS_ASSIGNMENT_SCHEDULE_ENDPOINT}/${busAssignmentScheduleId}`;
      const payload = {
        startDate,
        endDate,
        busIdList,
        circuitIdList,
        active: active || false,
      };
      const promise = await fetch(url, {
        ...DEFAULT_PUT_CONFIG,
        body: JSON.stringify(payload),
      });
      await isErrorResponse(promise, null, dispatch);
      await promise.json();
      dispatch(
        push(`${BUS_ASSIGNMENT_SCHEDULE_PATH}/${busAssignmentScheduleId}`),
      );
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagBusAssignmentScheduleActivity(false));
    }
  };

const getExportBusAssignmentSchedules = async () => async (dispatch) => {
  try {
    dispatch(flagGettingBusAssignmentSchedules(true));
    const url = `${BUS_ASSIGNMENT_SCHEDULE_ENDPOINT}/export`;
    const promise = await fetch(url, DEFAULT_GET_CONFIG);
    await isErrorResponse(promise, null, dispatch);
    const blob = await promise.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.download = 'asignacion_de_rutas.xlsx';
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch ({ message }) {
    toastr.error('Error', message);
  }
  finally {
    dispatch(flagGettingBusAssignmentSchedules(false));
  }
}

export {
  flagGettingBusAssignmentSchedules,
  getBusAssignmentSchedules,
  clearBusAssignmentSchedules,
  flagBusAssignmentScheduleActivity,
  getBusAssignmentSchedule,
  clearBusAssignmentSchedule,
  deleteBusAssignmentSchedule,
  postBusAssignmentSchedule,
  putBusAssignmentSchedule,
  getExportBusAssignmentSchedules
};
